var $ = require('jquery')

$(function () {
  $('button[data-append-param]').on('click', function () {
    // Get attribute
    const attr = parseAttribute($(this), 'data-append-param')
    // Get the current url
    const url = new URL(window.location)
    // Original URL parameter
    const originalParameter = url.searchParams.get(attr[0])
    // Set URL parameter to be
    url.searchParams.set(attr[0], attr[1])

    // After updating the url, is the parameter still the same?
    const paramChanged = url.searchParams.get(attr[0]) !== originalParameter

    /**
     * If we're toggling off a previously toggled attribute
     */
    if (!paramChanged) {
      url.searchParams.delete(attr[0])
    } else {
      // We are changing the parameter, check if we're on some other page than 1
      let isFirstPage = url.searchParams.get('number') == 1

      if (!isFirstPage) {
        url.searchParams.set('number', 1)
      }
    }

    // Update URL
    window.history.pushState({ path: url.href }, '', url.href)
    let popStateEvent = new PopStateEvent('popstate', { path: url.href })
    dispatchEvent(popStateEvent)

    $('button[data-append-param]').each(function () {
      const _attr = parseAttribute($(this), 'data-append-param')

      if (_attr[1] == attr[1])
        return paramChanged
          ? enableButtonState($(this))
          : disableButtonState($(this))

      return disableButtonState($(this))
    })
  })

  $('button[data-append-param]').each(function () {
    // If this category (specified in attr) exists in the url, replace button-tag-red with button-tag-red-fill

    const attr = parseAttribute($(this), 'data-append-param')

    const url = new URL(window.location)

    if (url?.searchParams.get(attr[0]) == attr[1]) enableButtonState($(this))
  })

  /**
   * Toggles button state to visually be "off"
   */
  function disableButtonState (elem) {
    elem.removeClass('button-tag-red-fill')
    elem.addClass('button-tag-red')
  }

  /**
   * Toggles button state to visually be "on"
   */
  function enableButtonState (elem) {
    elem.removeClass('button-tag-red')
    elem.addClass('button-tag-red-fill')
  }

  /**
   * Gets the attribute and its value
   */
  function parseAttribute (elem, attr) {
    return elem.attr(attr)?.split('=')
  }
})
